import { ICompanyList } from '@literax/models/company.model';

export interface ICompanyState {
  companies: ICompanyList[];
}

export const initialCompanyState: ICompanyState = {
  companies: []
};
